import "./svg/meny-mer-coupons.svg"

export default {
    name: "meny-mer-coupons",
    viewBox: "104 104",
}
